import { useI18n } from '@/i18n/useI18n';

export function AuthLogo() {
  const { language, t } = useI18n();
  const src = language === 'en' ? '/sloy-logo-en.svg' : '/sloy-logo-ru.svg';

  return (
    <img
      src={src}
      alt={t('app.name')}
      className="absolute top-16 left-1/2 h-16 w-auto -translate-x-1/2"
    />
  );
}
